module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ar-SA.37869fd6.jpg";